import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { FC } from 'react';
import FloorDrawing from './FloorDrawing';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const FloorModal: FC<{
    open: boolean;
    setOpen: (open: boolean) => void;
    fairID: number;
    fairName: string;
    floorPlan?: any;
    setFloorPlan: (floorPlan: any) => void;
    fetchFairDetails: () => Promise<void>;
}> = ({ open, setOpen, floorPlan, fairID, fairName, fetchFairDetails, setFloorPlan }) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
          <FloorDrawing
              floorPlan={floorPlan}
              fairID={fairID}
              handleClose={handleClose}
              fairName={fairName}
              fetchFairDetails={fetchFairDetails}
              setFloorPlan={setFloorPlan}
          />
      </Dialog>
    </React.Fragment>
  );
};
